import { AddBusinessOutlined } from "@mui/icons-material";
import { Button, Card, CircularProgress } from "@mui/material";
import { isEmpty, isNil } from "lodash";

import { useNavigate } from "react-router-dom";
import FinancingRequestItem from "../financingRequests/FinancingRequestItem";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";

const SubmittedFinancingRequestsRenderer = ({ financingRequests }) => {
  const navigate = useNavigate();
  if (isNil(financingRequests)) {
    return (
      <Card sx={{ py: 3 }}>
        <Flx g={2} center fw column>
          <CircularProgress size={18} />
          <Txt secondary>Getting your submitted financing requests...</Txt>
        </Flx>
      </Card>
    );
  }
  if (isEmpty(financingRequests)) {
    return (
      <Card sx={{ py: 6, px: 4 }}>
        <Flx g={1} center fw column>
          <AddBusinessOutlined sx={{ fontSize: "36px " }} className="thin" />
          <Txt bold center>
            No Applications Yet
          </Txt>
          <Txt secondary center>
            Ready to get started? Create your first loan application to begin
            the process.
          </Txt>
          <Button
            sx={{ mt: 2 }}
            onClick={() => navigate("/financing-request/create")}
          >
            Start a New Financing Request
          </Button>
        </Flx>
      </Card>
    );
  }

  return (
    <Flx g={4} column>
      {financingRequests?.map((f, index) => {
        const filteredUnderwritingRequirements =
          f?.underwritingRequirements?.filter(
            (req) =>
              req?.status !== "Accepted" &&
              req?.docStipStatus !== "Received - Pending Review" &&
              req?.docStipStatus !== "Accepted",
          );
        return (
          <FinancingRequestItem
            key={f._id}
            data={f}
            defaultOpen={!isEmpty(filteredUnderwritingRequirements)}
          />
        );
      })}
    </Flx>
  );
};

// Sub-component: Individual grid item

export default SubmittedFinancingRequestsRenderer;
